import { emptyTranslationSet } from "@src/utils/prompts";
import { updateTranslationSet } from "@src/utils/translationSets";
import { useAtomCallback } from "jotai/utils";
import { cloneDeep } from "lodash";
import { useContext, useCallback } from "react";
import { TranslationModeContext } from "../../course/contexts/TranslationModeContextProvider";
import { trainingResourceVersionAtom } from "../atoms";
import { useDispatchTrainingResourceBuilderAction } from "./useDispatchTrainingResourceBuilderAction";

export const useDispatchSetRichTextDocumentContentAction = (): Return => {
  const translationModeContext = useContext(TranslationModeContext);
  const dispatch = useDispatchTrainingResourceBuilderAction();
  return useAtomCallback(
    useCallback(
      (get, _set, args) => {
        const richTextDocument = get(
          trainingResourceVersionAtom,
        )?.richTextDocument;
        if (!richTextDocument) return;
        if (richTextDocument.id !== args.richTextDocumentId) return;
        dispatch({
          action: {
            payload: {
              setRichTextDocumentContentAction: {
                content: updateTranslationSet({
                  ts:
                    cloneDeep(richTextDocument?.content) ||
                    emptyTranslationSet(),
                  lang: translationModeContext?.currentLang || "en",
                  text: args.newText,
                }),
                richTextDocumentId: args.richTextDocumentId,
              },
            },
          },
          inverseAction: {
            payload: {
              setRichTextDocumentContentAction: {
                content: richTextDocument.content || emptyTranslationSet(),
                richTextDocumentId: args.richTextDocumentId,
              },
            },
          },
        });
      },
      [dispatch, translationModeContext?.currentLang],
    ),
  );
};
export type Return = (args: {
  richTextDocumentId: string;
  newText: string;
}) => void;
